function SubItem() {
  return (
    <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.2" d="M13 17H1L1 0" stroke="#736E7D" strokeWidth="2" />
    </svg>
  )
}

export default SubItem
